import { ReactChild } from 'react';
import cn from 'classnames';
import styles from './PlanButton.module.css';
import { PaymentPlanStatus, Plan } from '../Dashboard.types';

const PlanButton = ({
    status,
    selectedPlanId,
    paymentPlan,
    selectPaymentPlan,
    children
}: {
    status: PaymentPlanStatus | null;
    selectedPlanId: string | null;
    paymentPlan: Plan;
    selectPaymentPlan: (plan: Plan, isActive: boolean) => void;
    children: ReactChild;
}) => (
    <button
        className={cn(styles.paymentButton, {
            [styles.active]: selectedPlanId === paymentPlan!.pay_link_id,
            [styles.paymentOverdue]: status === 'overdue'
        })}
        onClick={() => selectPaymentPlan(paymentPlan, true)}
    >
        {children}
    </button>
);

// eslint-disable-next-line import/no-default-export
export default PlanButton;
